import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3decd905&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3decd905&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3decd905",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3decd905')) {
      api.createRecord('3decd905', component.options)
    } else {
      api.reload('3decd905', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3decd905&scoped=true", function () {
      api.rerender('3decd905', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/userServiceTwo/index.vue"
export default component.exports